<template>
  <div class="special-code">
    <div class="special-code-header">
      <header-close :deactivate="deactivate" :back="back">{{
          tc('booking.specialCode')
        }}
      </header-close>
    </div>

    <div class="special-code-content">
      <form class="form">
        <fieldset style="padding: 0">
          <legend class="sr-only">{{ tc('booking.specialCode') }}</legend>
          <div class="fields-wrapper">
            <div class="input dropdown specialCodeType">
              <select
                id="specialCodeType"
                name="specialCodeType"
                v-model="specialCodeType"
                data-field-type="DropdownList"
                class=""
              >
                <option value=""></option>
                <option v-if="!isBookingEditMode" value="iataNumber">{{ tc('formFields.iataNumber') }}</option>
                <option value="promotionCode">{{ tc('formFields.promoCode') }}</option>
                <option value="groupCode">{{ tc('formFields.groupCode') }}</option>
              </select>
              <label for="specialCodeType" class="floating">{{ tc('formFields.codeType') }}</label>
            </div>
            <div class="input specialCodeInput">
              <input
                type="text"
                id="specialCodeInput"
                @keypress.enter.prevent="submit"
                @keypress.space.prevent="submit"
                name="specialCodeInput"
                v-model="specialCodeValue"
                data-field-type="SingleLineText"
                :class="[{ 'no-value': !specialCodeValue }, { 'has-value': specialCodeValue }, { valid: !!specialCodeValue }, {'input-validation-error': employeePromosError}]"
              />
              <label for="specialCodeInput" class="floating"
              >{{ tc('formFields.enterSpecialCode') }}</label
              >
            </div>
            <div class="button-wrapper">
              <button
                :aria-disabled="!specialCodeType || !specialCodeValue"
                :aria-label="`${tc('booking.apply')} ${tc('booking.specialCode')}`"
                class="special-code-apply"
                :class="{'special-code-apply_disabled': !specialCodeType || !specialCodeValue}"
                tabindex="0"
                type="button"
                @click="!specialCodeType || !specialCodeValue ? null : submit()"
              >
                {{ tc('booking.apply') }}
              </button>
            </div>
          </div>
        </fieldset>
      </form>
      <div v-if="employeePromosError" class="special-code-error-box">
        <span class="special-code-error-message">
          {{
            tc('errors.promoCodeOnlyLoggedUser')
          }}
        </span>
        <div v-if="!user" class="special-code-signin">
          <auth-activator>
            <template slot-scope="{ activate }">
              <a
                href="#"
                @click.prevent="activate('login', $event.target)"
                @keydown.space.prevent="activate('login', $event.target)"
              >
                {{ tc('auth.signIn') }}
              </a>
            </template>
          </auth-activator>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import TabTrapMixin from '@mixins/tab-trap'
  import HeaderClose from '../header-close/header-close.vue'

  export default {
    name: 'SpecialCode',
    components: {
      HeaderClose,
    },
    mixins: [TabTrapMixin],
    props: {
      checkAvailability: {
        type: Function,
        required: true,
      },
      deactivate: {
        type: Function,
        required: true,
      },
      currentHotel: {
        type: String,
        required: false,
      },
    },
    inject: ['updateLocalQuery', 'localQuery'],
    data: () => ({
      isLoading: false,
      specialCodesOpened: false,
      specialCodeType: null,
      specialCodeValue: null,
      iataNumber: null,
      promotionCode: null,
      groupCode: null,
      tooltipOpened: false,
      scrollHeight: 'auto',
      isTravelAgent: false,
      employeePromosError: false,
    }),
    watch: {
      user(val) {
        if (val) {
          this.employeePromosError = false
        }
      }
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('booking', [
        'getDateRangeInDays',
        'getAdultDetails',
        'getRoomDetails',
        'getSummaryDetails',
      ]),
      ...mapGetters('hotelData', ['getHotelById']),
      ...mapState('responsive', { wHeight: 'height' }),
      ...mapState('auth', ['user']),
      ...mapState('modifyReservation', ['isBookingEditMode']),
      employeePromos() {
        return ['81MOCO81', '81STAY*2022', '22FMO6'].map((m) => m.toLocaleLowerCase())
      },
      selectedHotel() {
        return this.getHotelById(this.localQuery.hotelCode)
      },
      localRangeInDays() {
        return Math.round(this.getDateRangeInDays(this.localQuery))
      },
      havePromoValues() {
        return !!this.iataNumber || !!this.promotionCode || !!this.groupCode
      },
      onlyForSignedIn() {
        return (
          this.specialCodeValue
          && this.employeePromos.includes(this.specialCodeValue.trim().toLocaleLowerCase())
          && !this.user
        )
      },
    },
    mounted() {
      this.$emit('change-width', 'default')
      const queryParams = new URLSearchParams(window.location.search)
      const iataNumber = queryParams.get('iataNumber')
      const promotionCode = queryParams.get('promotionCode')
      const groupCode = queryParams.get('groupCode')
      this.isTravelAgent = !!iataNumber
      this.iataNumber = iataNumber ?? this.localQuery.iataNumber
      this.promotionCode = promotionCode ?? this.localQuery.promotionCode
      this.groupCode = groupCode ?? this.localQuery.groupCode
    },
    methods: {
      async submit() {
        if (this.onlyForSignedIn) {
          this.$el.querySelector('[id="specialCodeInput"]')
            .scrollIntoView()
          this.employeePromosError = true
          return
        }
        switch (this.specialCodeType) {
          case 'iataNumber':
            this.updateLocalQuery({
              prop: 'iataNumber',
              value: this.specialCodeValue
            })
            break
          case 'promotionCode':
            this.updateLocalQuery({
              prop: 'promotionCode',
              value: this.specialCodeValue,
            })
            break
          case 'groupCode':
            this.updateLocalQuery({
              prop: 'groupCode',
              value: this.specialCodeValue
            })
            break
          default:
            break
        }
        this.isLoading = false
        this.specialCodeType && this.specialCodeValue && this.back()
      },
      back() {
        this.$emit('change-page', 'calendar')
      }
    }
  }
</script>
